import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-no-record',
  templateUrl: './no-record.component.html',
  styleUrls: ['./no-record.component.css']
})
export class NoRecordComponent {
  @Input() customMessage: string | null = null;
  @Input() customWidth: string | null = null;
  @Input() showCard = true;
  @Input() buttonText: string | null = null;
  @Input() icon = 'fa-search';
  @Output() buttonPressed = new EventEmitter<void>();
}
